import panels from './panels';
import members from './members';
import reportApi from './reportApi';

export default {
	panels,
	members,
	reportApi
};
